import type { Store } from '@personnel/domain/entities/Store';
import { createStoreFromData } from '@personnel/domain/entities/Store';
import type { ApiStore } from '@personnel/infrastructure/api/types/StoreApiResponse';

export const transformApiStoreToEntity = (apiStore: ApiStore): Store =>
  createStoreFromData({ uuid: apiStore.uuid, name: apiStore.name, isDraft: apiStore.isDraft ?? false });
